import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';

@Component({
    standalone: false,
    selector: 'info-analysis',
    templateUrl: "./info-analysis.component.html",
    encapsulation: ViewEncapsulation.None
})
export class InfoAnalysisComponent implements OnInit {
    @Input() infotTitle: string;
    @Input() description: string;
    @Input() colorClass: string;

    constructor() {
    }

    ngOnInit() {
    }

}
